import { Grid } from '@material-ui/core'
import animateScroll from 'animated-scroll-to'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  paymentMethodSelected,
  phaseChange,
  reroute,
  storeDumpItForce,
} from '../../../actions/Buy'
import { postLastStepVisitedLead } from '../../../actions/common/Step'
import { getCmsCanoniV4 } from '../../../actions/noleggia/Cms'
import { postOriniNltV1 } from '../../../actions/noleggia/Ordini'
import {
  getNltCanonePersonalizzatoV1,
  setCanonePersonalizzato,
  setSelectedAnticipo,
  setSelectedCanone,
  setSelectedNumeroMensilita,
} from '../../../actions/noleggia/ScegliCanone'
import { unSetAllServiziPlus } from '../../../actions/noleggia/ServiziPlus'
import { postUtentiNltV1 } from '../../../actions/noleggia/Utenti'
import { ROUTES } from '../../../constants/routes'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import { getFromFee, isNltBrumbrum } from '../../../utils/nltUtils'
import BuyButton from '../../buy/dumb/BuyButton'
import BuyCartRow from '../../buy/dumb/BuyCartRow'
import BuyPricePromozione from '../../buy/dumb/BuyPricePromozione'
import BuyTextInput from '../../buy/dumb/BuyTextInput'
import {
  preparaValoriLogistica,
  restartSellout,
  restartSelloutCheckpoints,
} from '../../buy/utils'
import Coupon from '../../Input/Coupon'
import CouponHelperModal from '../dumb/CouponHelperModal'
import MiniCartNlt from '../dumb/MinicartNlt'
import ServiziInclusi from '../dumb/ServiziInclusi'
import formatCilindrata from '../formatCilindrata'

class ScegliCanone extends Component {
  constructor(props) {
    super(props)
    this.state = {
      canoneChanged: false,
      showCanonePersonalizzato: false,
      canonePersonalizzato: '',
      isCanonePersonalizzatoFormatValid: true,
      isEECTracked: false,
      showConfermaCodiceAccettato: false,
      show_coupon_helper_modal: false,
    }
    this.nltBrumbrumHowItWorks = this.nltBrumbrumHowItWorks.bind(this)
  }

  componentWillMount() {
    if (
      !restartSellout(
        restartSelloutCheckpoints.SCEGLI_CANONI,
        this.props.reroute,
        this.props.customer
      )
    ) {
      if (!this.props.nlt.selectedCanone) {
        this.props.getCmsCanoniV4(this.props.product.id_auto)
      }
    }

    if (this.props.nlt.serviziPlusSelected) {
      this.props.unSetAllServiziPlus()
    }

    window.scrollTo(0, 0)
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 10, last: 0 })
    this.props.storeDumpItForce()
    this.props.paymentMethodSelected({ method: 'noleggio' })

    animateScroll(0)

    this.props.postLastStepVisitedLead().catch(() => null)

    if (!this.state.isEECTracked) {
      this.setState(
        {
          isEECTracked: true,
        },
        () =>
          enhancedEcommerceTracker
            .pushCheckout(
              {
                product: this.props.product,
                ordine: this.props.ordine,
                nlt: this.props.nlt,
              },
              1
            )
            .then(() => {})
      )
    }
  }

  setNumeroMensilita(numeroMensilita) {
    const t = this
    return () => {
      t.props.setSelectedNumeroMensilita({
        selectedNumeroMensilita: numeroMensilita,
      })
      t.updateSelectedCanone(null, numeroMensilita)
    }
  }

  setAnticipo(anticipo) {
    const t = this
    return () => {
      t.props.setSelectedAnticipo({ selectedAnticipo: anticipo })
      t.updateSelectedCanone(anticipo, null)
    }
  }

  updateSelectedCanone(newAnticipo = null, newNumeroMensilita = null) {
    const selectedAnticipo =
      newAnticipo !== null ? newAnticipo : this.anticipo()
    const selectedNumeroMensilita = newNumeroMensilita || this.numeroMensilita()
    const idCanone =
      this.props.nlt.anticipoNumeroMensilita[
        `${selectedAnticipo}_${selectedNumeroMensilita}`
      ]
    const selectedCanone = this.props.nlt.canoniIndexed[idCanone]
    this.props.setSelectedCanone({ selectedCanone })
    this.setState({
      canoneChanged: true,
    })
  }

  isDefaultAnticipo(anticipo) {
    if (this.props.nlt.selectedAnticipo !== null) {
      return this.props.nlt.selectedAnticipo === anticipo
    }
    return this.props.nlt.selectedCanone.anticipo === anticipo
  }

  isDefaultNumeroMensilita(numeroMensilita) {
    if (this.props.nlt.selectedNumeroMensilita) {
      return this.props.nlt.selectedNumeroMensilita === numeroMensilita
    }
    return this.props.nlt.selectedCanone.numero_mensilita === numeroMensilita
  }

  anticipo() {
    if (this.props.nlt.selectedAnticipo !== null) {
      return this.props.nlt.selectedAnticipo
    }
    return this.props.nlt.selectedCanone.anticipo
  }

  numeroMensilita() {
    if (this.props.nlt.selectedNumeroMensilita) {
      return this.props.nlt.selectedNumeroMensilita
    }
    return this.props.nlt.selectedCanone.numero_mensilita
  }

  handleProsegui() {
    const t = this
    return () => {
      if (this.props.ordine.id_ordine) {
        if (this.state.canoneChanged) {
          t.props.reroute().then(() => {
            t.props.postOriniNltV1().then(() => {
              this.setState({
                canoneChanged: false,
              })
              t.props.reroute(ROUTES.SERVIZI_PLUS)
            })
          })
        } else {
          t.props.reroute(ROUTES.SERVIZI_PLUS)
        }
      } else {
        t.props.reroute().then(() => {
          t.props.postUtentiNltV1().then(() => {
            t.props.postOriniNltV1().then(() => {
              t.props.reroute(ROUTES.SERVIZI_PLUS)
            })
          })
        })
      }

      fbPixel(FB_EVENTS.AddToCart, t.props.product)
      enhancedEcommerceTracker
        .pushCheckoutOption(
          1,
          `${t.props.nlt.selectedCanone?.anticipo}€ - ${t.props.nlt.selectedCanone?.numero_mensilita}mesi`
        )
        .then(() => {})
    }
  }

  handleInput(inputName) {
    const t = this
    return event => {
      t.setState({
        [inputName]: event.target.value
          ? event.target.value.trim()
          : event.target.value,
      })
    }
  }

  handleCoupon() {
    const t = this
    return async coupon => {
      if (coupon.error) {
        t.setState({
          isCanonePersonalizzatoFormatValid: false,
        })
      } else {
        t.setState({
          showCanonePersonalizzato: false,
          isCanonePersonalizzatoFormatValid: true,
          showConfermaCodiceAccettato: true,
        })

        t.props.setCanonePersonalizzato(coupon.value)

        try {
          await t.props.getNltCanonePersonalizzatoV1()
          return true
        } catch (e) {
          t.setState({
            isCanonePersonalizzatoFormatValid: false,
          })

          t.props.setCanonePersonalizzato('')

          return false
        }
      }
    }
  }

  handleCanonePersonalizzato() {
    const t = this
    return () => {
      const cp = t.state.canonePersonalizzato
      // questa regex e' per i codici stripe non per i canoni nlt
      // if (RegExp('BRUM-[CP]{1}-[A-HJ-NP-RT-Y0-9]{6}$').exec(cp.toUpperCase()) === null) {
      if (
        /^((brum-[0-9a-z]{4})|([0-9a-z]{1,}-(c|p)-[0-9a-hj-np-rt-y]{6}))/i.exec(
          cp.toUpperCase()
        ) === null
      ) {
        t.setState({
          isCanonePersonalizzatoFormatValid: false,
        })
        return
      }

      t.setState({
        showCanonePersonalizzato: false,
        isCanonePersonalizzatoFormatValid: true,
        showConfermaCodiceAccettato: true,
      })

      setTimeout(() => t.setState({ showConfermaCodiceAccettato: false }), 3000)
      t.props.setCanonePersonalizzato(cp)
      t.props.getNltCanonePersonalizzatoV1().catch(() => {
        /**
         * resetta il codice canone personalizzato per sbloccare
         * l'overlay e i pulsanti della scelta canoni
         */
        t.props.setCanonePersonalizzato('')
      })
    }
  }

  showCanonePersonalizzato() {
    const t = this
    return () => {
      t.setState({
        showCanonePersonalizzato: true,
      })
    }
  }

  hideCanonePersonalizzato() {
    const t = this
    return () => {
      t.setState({
        showCanonePersonalizzato: false,
      })
    }
  }

  nltBrumbrumHowItWorks() {
    return null
  }

  totale() {
    return this.props.pricing.total
  }

  render() {
    const { product } = this.props

    const personalizzaCanoneDisabled =
      this.props.nlt.selectedCanone && this.props.nlt.selectedCanone.custom

    const valoriLogistica = preparaValoriLogistica(
      this.totale(),
      this.props.logistica
    )
    return (
      <section className="process scegliCanone">
        {/* <div className="process__header"> */}
        {/* <h1 className="process__title">Scegli il tuo canone mensile</h1> */}
        {/* <p>Componi il tuo canone scegliendo l'anticipo e la durata del tuo noleggio</p> */}
        {/* </div> */}
        <div className="user-informations hide-small">
          <div className="container_small">
            <div className="process__column process__column__right right_tre_colonne colonna_uno">
              <ServiziInclusi
                canone={
                  this.props.nlt && this.props.nlt.selectedCanone
                    ? this.props.nlt.selectedCanone
                    : undefined
                }
                product={this.props.product}
              />
            </div>
            {this.props.nlt.anticipi && this.props.nlt.numeroMensilita && (
              <div className="process__column process__column__right right_tre_colonne colonna_due">
                <div className={`box-elementi`}>
                  <div
                    className={`${
                      personalizzaCanoneDisabled
                        ? 'personalizzaCanoneDisabled'
                        : ''
                    }`}
                  >
                    <h3 className="section-subtitle">Personalizza l'importo</h3>
                    <b className="mini-title">Scegli l'anticipo</b>
                    <div className="pulsanti-action">
                      {this.props.nlt.anticipi
                        .sort()
                        .reverse()
                        .map(anticipo => (
                          <button
                            className={
                              this.isDefaultAnticipo(anticipo) ? 'default' : ''
                            }
                            disabled={personalizzaCanoneDisabled}
                            key={anticipo}
                            onClick={this.setAnticipo(anticipo)}
                          >
                            € {anticipo}
                          </button>
                        ))}
                    </div>

                    <div className="space-20"></div>

                    <b className="mini-title text-center">Scegli la durata</b>
                    <div className="pulsanti-action">
                      {this.props.nlt.numeroMensilita
                        .sort()
                        .map(numeroMensilita => (
                          <button
                            className={
                              this.isDefaultNumeroMensilita(numeroMensilita)
                                ? 'default'
                                : ''
                            }
                            disabled={personalizzaCanoneDisabled}
                            key={numeroMensilita}
                            onClick={this.setNumeroMensilita(numeroMensilita)}
                          >
                            {numeroMensilita} mesi
                          </button>
                        ))}
                    </div>
                  </div>
                  <div className="space-40"></div>
                  <Grid container item justify="space-between" spacing={1}>
                    <Grid item>
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          letterSpacing: '0.1px',
                          wordSpacing: '-1px',
                        }}
                      >
                        Codice coupon o promozionale
                      </span>
                    </Grid>
                    <Grid item>
                      <a
                        className="help-link"
                        onClick={e => {
                          e.preventDefault()
                          this.setState({ show_coupon_helper_modal: true })
                        }}
                      >
                        Hai bisogno di aiuto?
                      </a>
                    </Grid>
                  </Grid>
                  <div className="space-20"></div>
                  <Grid container justify="center">
                    <Grid container item xs={12}>
                      <Coupon
                        label={'Applica'}
                        maxCoupons={2}
                        name={'coupon'}
                        onCouponSubmitted={this.handleCoupon()}
                        selloutSettings={
                          this.props.ui.sellout_settings_noleggia
                        }
                        starterCoupon={this.props.nlt.codiceCoupon}
                      />
                    </Grid>
                  </Grid>
                  {this.nltBrumbrumHowItWorks()}
                </div>
              </div>
            )}
            <div className="process__column process__column__right right_tre_colonne colonna_tre">
              <MiniCartNlt
                {...valoriLogistica}
                nlt={this.props.nlt}
                product={product}
                ui={this.props.ui}
              />
              <div className="space-20"></div>
              <p className="text-center">
                <BuyButton
                  classes={`btn btn-primary${
                    this.props.fetching ? ' btn-disabled' : ''
                  }`}
                  label={"Prosegui con l'ordine"}
                  update={this.handleProsegui()}
                />
              </p>
            </div>
          </div>
        </div>
        <div className="user-informations hide-large">
          <div className="container_small">
            {this.props.nlt.anticipi && this.props.nlt.numeroMensilita && (
              <div className="process__column process__column__center colonna_due">
                <div className={`box-elementi`}>
                  <div
                    className={`${
                      personalizzaCanoneDisabled
                        ? 'personalizzaCanoneDisabled'
                        : ''
                    }`}
                  >
                    <h3 className="section-subtitle text-center">
                      Personalizza l'importo
                    </h3>
                    <b className="mini-title">Scegli l'anticipo</b>
                    <div className="pulsanti-action">
                      {this.props.nlt.anticipi
                        .sort()
                        .reverse()
                        .map(anticipo => (
                          <button
                            className={
                              this.isDefaultAnticipo(anticipo) ? 'default' : ''
                            }
                            disabled={personalizzaCanoneDisabled}
                            key={anticipo}
                            onClick={this.setAnticipo(anticipo)}
                          >
                            € {anticipo}
                          </button>
                        ))}
                    </div>

                    <div className="space-50"></div>

                    <b className="mini-title">Scegli la durata</b>
                    <div className="pulsanti-action">
                      {this.props.nlt.numeroMensilita
                        .sort()
                        .map(numeroMensilita => (
                          <button
                            className={
                              this.isDefaultNumeroMensilita(numeroMensilita)
                                ? 'default'
                                : ''
                            }
                            disabled={personalizzaCanoneDisabled}
                            key={numeroMensilita}
                            onClick={this.setNumeroMensilita(numeroMensilita)}
                          >
                            {numeroMensilita} mesi
                          </button>
                        ))}
                    </div>
                  </div>
                  <div className="space-50"></div>
                  <Grid container item justify="space-between" spacing={1}>
                    <Grid item>
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          letterSpacing: '0.1px',
                          wordSpacing: '-1px',
                        }}
                      >
                        Codice coupon o promozionale
                      </span>
                    </Grid>
                    <Grid item>
                      <a
                        className="help-link"
                        onClick={e => {
                          e.preventDefault()
                          this.setState({ show_coupon_helper_modal: true })
                        }}
                      >
                        Hai bisogno di aiuto?
                      </a>
                    </Grid>
                  </Grid>
                  <div className="space-20"></div>
                  <Grid container justify="center">
                    <Grid container item xs={12}>
                      <Coupon
                        label={'Applica'}
                        maxCoupons={2}
                        name={'coupon'}
                        onCouponSubmitted={this.handleCoupon()}
                        selloutSettings={
                          this.props.ui.sellout_settings_noleggia
                        }
                        starterCoupon={this.props.nlt.codiceCoupon}
                      />
                    </Grid>
                  </Grid>
                  <div className="space-50 hide-mobile"></div>
                  {this.nltBrumbrumHowItWorks()}
                </div>
              </div>
            )}
            <div className="process__column process__column__center colonna_tre">
              <div className="the-cart">
                <div className="f-table cart" style={{ marginBottom: '36px' }}>
                  <div className={'section-cart'}>
                    <h5 className={'section-title --reduced'}>
                      Riepilogo Canone
                    </h5>
                    {this.props.nlt && this.props.nlt.selectedCanone && (
                      <BuyCartRow
                        label={'Anticipo'}
                        pricePromozione={
                          <BuyPricePromozione
                            value={`€ ${numeral(
                              this.props.nlt.selectedCanone.anticipo
                            ).format('0[,]00')} (IVA incl.)`}
                          />
                        }
                      />
                    )}
                    {this.props.nlt && this.props.nlt.selectedCanone && (
                      <BuyCartRow
                        label={'Durata'}
                        pricePromozione={
                          <BuyPricePromozione
                            value={`${this.props.nlt.selectedCanone.numero_mensilita} mesi`}
                          />
                        }
                      />
                    )}
                    {this.props.nlt &&
                    this.props.nlt.selectedCanone &&
                    isNltBrumbrum(this.props.product) ? (
                      <BuyCartRow
                        label={'Chilometri inclusi'}
                        pricePromozione={
                          <BuyPricePromozione
                            value={`${numeral(
                              this.props.nlt.selectedCanone.km_inclusi *
                                (this.props.nlt.selectedCanone
                                  .numero_mensilita /
                                  12)
                            ).format('0[,]00')} (max ${numeral(
                              this.props.nlt.selectedCanone.km_inclusi
                            ).format('0[,]00')}
                            /anno)`}
                          />
                        }
                      />
                    ) : null}
                    {this.props.nlt &&
                    this.props.nlt.selectedCanone &&
                    !isNltBrumbrum(this.props.product) ? (
                      <BuyCartRow
                        label={'Chilometri inclusi'}
                        pricePromozione={
                          <BuyPricePromozione
                            value={numeral(
                              this.props.nlt.selectedCanone.km_inclusi
                            ).format('0[,]00')}
                          />
                        }
                      />
                    ) : null}
                    {this.props.nlt && this.props.nlt.codiceCoupon && (
                      <BuyCartRow
                        label={this.props.nlt.minicartLabelCoupon}
                        pricePromozione={
                          <BuyPricePromozione
                            value={this.props.nlt.codiceCoupon}
                          />
                        }
                      />
                    )}
                    {this.props.nlt && this.props.nlt.canonePersonalizzato && (
                      <BuyCartRow
                        label={this.props.nlt.minicartLabelCanonePersonalizzato}
                        pricePromozione={
                          <BuyPricePromozione
                            value={this.props.nlt.canonePersonalizzato}
                          />
                        }
                      />
                    )}

                    {this.props.nlt &&
                      this.props.nlt.selectedCanone &&
                      !isNltBrumbrum(this.props.product) && (
                        <BuyCartRow
                          extraCss={'row-canone-riepilogo-canone-mobile'}
                          label={'Canone totale'}
                          pricePromozione={
                            <BuyPricePromozione
                              value={
                                <React.Fragment>
                                  <b
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: 400,
                                    }}
                                  >
                                    €
                                    {numeral(
                                      this.props.nlt.selectedCanone
                                        .canone_mensile
                                    ).format('0,0')}
                                  </b>
                                  /mese (IVA incl.)
                                </React.Fragment>
                              }
                            />
                          }
                        />
                      )}

                    {(this.props.nlt.serviziPlusSelected.length > 0 ||
                      isNltBrumbrum(this.props.product)) &&
                      this.props.nlt.selectedCanone &&
                      this.props.nlt.selectedCanone.canone_mensile && (
                        <div
                          className={`row canoneBase ${
                            isNltBrumbrum(this.props.product) ? 'gray' : ''
                          }`}
                        >
                          <div className="left">
                            <ul>
                              <li style={{ fontWeight: 700 }}>
                                {isNltBrumbrum(this.props.product)
                                  ? 'Canone mensile'
                                  : 'Canone base'}
                              </li>
                            </ul>
                          </div>
                          <div className="right">
                            <span>
                              <span
                                className={`${
                                  isNltBrumbrum(this.props.product)
                                    ? 'text-grey800'
                                    : ''
                                }`}
                              >
                                €{' '}
                                {isNltBrumbrum(this.props.product)
                                  ? this.props.nlt.selectedCanone
                                      .canone_mensile +
                                    this.props.nlt.selectedCanone
                                      .cap_variabile_kilometrico
                                  : this.props.nlt.selectedCanone
                                      .canone_mensile}
                              </span>
                              /mese (IVA incl.)
                            </span>
                          </div>
                        </div>
                      )}

                    {this.props.nlt &&
                    this.props.nlt.selectedCanone &&
                    !isNltBrumbrum(this.props.product) ? (
                      <BuyCartRow
                        extraCss={'row-canone-riepilogo-canone-mobile'}
                        label={'Costo chilometrico'}
                        pricePromozione={
                          <BuyPricePromozione
                            value={
                              <React.Fragment>
                                <b
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                  }}
                                >
                                  €{this.props.nlt.selectedCanone.fee_km}
                                </b>
                                /km (IVA incl.)
                              </React.Fragment>
                            }
                          />
                        }
                      />
                    ) : null}

                    {isNltBrumbrum(this.props.product) && (
                      <div className="row gray">
                        <div className="left" style={{ fontWeight: 700 }}>
                          Canone minimo
                        </div>
                        <div className="right">
                          <span className="text-grey800">
                            €
                            {numeral(
                              getFromFee(
                                'canone_mensile',
                                this.props.nlt.selectedCanone
                              )
                            ).format()}
                          </span>
                          /mese (IVA incl.)
                        </div>
                        <br style={{ clear: 'both' }} />
                        <div style={{ display: 'block' }}>
                          <p
                            className="nlt-brumbrum-offer-info"
                            style={{ fontSize: '13px' }}
                          >
                            Con l'offerta brumbrum se guidi poco spendi meno e
                            per quest'auto puoi risparmiare fino a €
                            {numeral(
                              this.props.nlt.selectedCanone
                                .cap_variabile_kilometrico
                            ).format('0[,]00')}
                            . Ogni chilometro percorso ha un costo di €
                            {numeral(
                              this.props.nlt.selectedCanone.fee_km
                            ).format('0[.]00')}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="the-cart">
                <div className="f-table cart">
                  <div className={'section-cart'}>
                    <h5 className={'section-title --reduced'}>
                      Riepilogo Auto
                    </h5>
                    <BuyCartRow
                      label={'Marca'}
                      pricePromozione={
                        <BuyPricePromozione value={product.marca} />
                      }
                    />
                    <BuyCartRow
                      label={'Modello'}
                      pricePromozione={
                        <BuyPricePromozione value={product.modello} />
                      }
                    />
                    <BuyCartRow
                      label={'Alimentazione'}
                      pricePromozione={
                        <BuyPricePromozione
                          value={`${formatCilindrata(product.cilindrata)} ${
                            product.alimentazione
                          }`}
                        />
                      }
                    />
                    <BuyCartRow
                      label={'Potenza'}
                      pricePromozione={
                        <BuyPricePromozione value={`${product.potenza} CV`} />
                      }
                    />
                    <BuyCartRow
                      label={'Cambio'}
                      pricePromozione={
                        <BuyPricePromozione value={product.cambio} />
                      }
                    />
                    <BuyCartRow
                      label={'Stato'}
                      pricePromozione={
                        <BuyPricePromozione value={product.tipo_veicolo} />
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="process__column process__column__center colonna_uno">
              <ServiziInclusi
                canone={
                  this.props.nlt && this.props.nlt.selectedCanone
                    ? this.props.nlt.selectedCanone
                    : undefined
                }
                product={this.props.product}
              />
              <div className="space-20"></div>
              <div className="next-button-wrapper-sticky text-center">
                {this.props.nlt &&
                this.props.nlt.selectedCanone &&
                isNltBrumbrum(this.props.product) ? (
                  <div className={'next-canone-info'}>
                    Noleggia la tua nuova auto
                  </div>
                ) : (
                  <div className={'next-canone-info'}>
                    Canone totale{' '}
                    <b>
                      €
                      {numeral(
                        getFromFee(
                          'canone_mensile',
                          this.props.nlt.selectedCanone
                        )
                      ).format('0,0')}
                    </b>
                    /mese IVA incl.
                  </div>
                )}
                <BuyButton
                  classes={`btn btn-primary${
                    this.props.fetching ? ' btn-disabled' : ''
                  }`}
                  label={'Prosegui'}
                  update={this.handleProsegui()}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${
            this.state.showCanonePersonalizzato
              ? 'show-canone-personalizzato'
              : 'hide-canone-personalizzato'
          }`}
          id={'canonePersonalizzatoWrapper'}
        >
          <div className="banner-canone-personalizzato">
            <a
              className="close-cross"
              onClick={this.hideCanonePersonalizzato()}
            >
              <span className="icons icons-times Header__Close-s30ym4f-1 idRNJo"></span>
            </a>

            <b className="mini-title">Hai un preventivo su misura?</b>
            <p>
              Inserisci il codice che hai ricevuto dal Servizio Clienti, clicca
              OK e visualizza l'importo del tuo canone.
            </p>
            <div className="space-20"></div>
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={''}
              label={''}
              onInput={this.handleInput('canonePersonalizzato')}
              placeholder={'Scrivi il Codice'}
              type={'text'}
              update={() => null}
            />
            <br />
            {this.state.isCanonePersonalizzatoFormatValid ? null : (
              <span>Codice preventivo non valido</span>
            )}
            <div className="space-50"></div>
            <BuyButton
              classes={`btn btn-primary${
                !this.state.canonePersonalizzato ? ' btn-disabled' : ''
              }`}
              label={'OK'}
              update={this.handleCanonePersonalizzato()}
            />
          </div>
        </div>
        <CouponHelperModal
          content={
            <div>
              <p>
                Per usufruire delle iniziative promozionali e di sconti puoi
                inserire nel campo il codice che hai ricevuto tramite email.
              </p>
              <p>
                Hai ricevuto dal nostro Servizio Clienti un codice personale o
                un preventivo su misura? Inserisci nel campo il codice che ti è
                stato fornito durante la telefonata e/o via email.
              </p>
              <p>
                Dopo aver inserito il codice, seleziona il pulsante per
                applicare la tua promozione. Visualizzerai subito i dettagli del
                tuo ordine aggiornati..
              </p>
            </div>
          }
          display={this.state.show_coupon_helper_modal}
          onClose={() => {
            this.setState({ show_coupon_helper_modal: false })
          }}
        />
      </section>
    )
  }
}

ScegliCanone.propTypes = {
  reroute: PropTypes.func,
  customer: PropTypes.object,
  fetching: PropTypes.bool,
  logistica: PropTypes.object,
  getCmsCanoniV4: PropTypes.func,
  nlt: PropTypes.object,
  ordine: PropTypes.object,
  phaseChange: PropTypes.func,
  postLastStepVisitedLead: PropTypes.func,
  product: PropTypes.object,
  setSelectedCanone: PropTypes.func,
  setCanonePersonalizzato: PropTypes.func,
  getNltCanonePersonalizzatoV1: PropTypes.func,
  unSetAllServiziPlus: PropTypes.func,
  storeDumpItForce: PropTypes.func,
}

const mapStateToProps = state => ({
  fetching: state.ui.fetching,
  customer: state.customer,
  nlt: state.nlt,
  ordine: state.ordine,
  product: state.product,
  logistica: state.logistica,
  ui: state.ui,
  pricing: state.pricing,
})

const mapDispatchToProps = dispatch => ({
  getCmsCanoniV4: () => dispatch(getCmsCanoniV4),
  getNltCanonePersonalizzatoV1: () => dispatch(getNltCanonePersonalizzatoV1),
  phaseChange: phase => dispatch(phaseChange(phase)),
  postUtentiNltV1: () => dispatch(postUtentiNltV1),
  postOriniNltV1: () => dispatch(postOriniNltV1),
  postLastStepVisitedLead: () => dispatch(postLastStepVisitedLead),
  reroute: rerouteTo => dispatch(reroute(rerouteTo)),
  setSelectedAnticipo: payload => dispatch(setSelectedAnticipo(payload)),
  setSelectedCanone: payload => dispatch(setSelectedCanone(payload)),
  setSelectedNumeroMensilita: payload =>
    dispatch(setSelectedNumeroMensilita(payload)),
  setCanonePersonalizzato: payload =>
    dispatch(setCanonePersonalizzato(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  unSetAllServiziPlus: payload => dispatch(unSetAllServiziPlus(payload)),
  paymentMethodSelected: payload => dispatch(paymentMethodSelected(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScegliCanone)
